import React from 'react';
import { Button, Box } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useFormContext } from 'react-hook-form';

const BackButton = ({ sx = {}, clearFormOnBack = true }) => {
  const navigate = useNavigate();
  const methods = useFormContext();

  const handleBack = () => {
    // Clear form data when navigating back if specified
    if (clearFormOnBack && methods) {
      methods.reset();
    }
    navigate(-1);
  };

  return (
    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start' }}>
      <Button
        startIcon={<ArrowBack />}
        onClick={handleBack}
        sx={{ 
          mb: 2, 
          color: '#ffffff',
          alignSelf: 'flex-start',
          backgroundColor: 'rgba(0,0,0,0)', // Ensuring the background is fully transparent
          '&:hover': {
            backgroundColor: 'action.hover', // Adding a hover effect
          },
          ...sx 
        }}
      >
        Back
      </Button>
    </Box>
  );
};

export default BackButton;
